import Vue from "vue";
import ListSfSupportRepository from "@/repositories/monocle/ListSfSupportRepository";

export interface MonocleSupport {
    uuid: string;
    label: string;
}

export default {
    state: {
        supports: [],
    },
    mutations: {
        setMonocleSupports: (
            state: any,
            supports: MonocleSupport[]
        ) => {
            Vue.set(state, "supports", supports);
        },
    },
    getters: {
        getMonocleSupports: (state: any): MonocleSupport[] => {
            return state.supports;
        },
    },
    actions: {
        loadMonocleSupports: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                const orders = { default: "DESC", label: "ASC" };
                const params = { orders };
                ListSfSupportRepository.get(params).then((data: any) => {
                    commit("setMonocleSupports", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
